const About = () => {
  return (
    <div>
      <h1>About this site</h1>
      <p>
        This is a hobby. It probably won't change too much. If it does, it's
        because I figured out what I want to do with it.
      </p>
      <p>
        There's not much to say. I'm an avid gamer and work in IT. I'm pretty
        much self-taught (with two years of computer science courses in college)
        and am learning as I go.
      </p>
    </div>
  );
};

export default About;
